import {VersionVariants} from '@jobseeker/lotus/enums';
import dynamic from 'next/dynamic';
import {AlertProps as MuiAlertProps} from '@mui/material';
import NotImplemented from '@jobseeker/lotus/elements/NotImplemented';
// import V2 from './V2';
import V1 from './V1';

const componentMap: any = {};
componentMap[VersionVariants.VERSION_ONE] = V1;
componentMap[VersionVariants.VERSION_TWO] = NotImplemented;

const AccordionGroup = (props: any) => {
  let Component;
  if (Object.keys(componentMap).includes(props.variant)) {
    Component = componentMap[props.variant];
  } else {
    Component = componentMap[VersionVariants.VERSION_ONE];
  }
  return <Component {...props} />;
};

export default AccordionGroup;
